///<reference path="../../../node_modules/@angular/core/src/metadata/directives.d.ts"/>
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AutologService} from './autolog.service';
import {DetectBrowserService} from '../detect-browser.service';
import {environment} from '../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {Rendezvous} from '../auth/signin/rendezvous';

@Component({
  selector: 'app-autolog',
  templateUrl: './autolog.component.html',
  styleUrls: ['./autolog.component.css']
})
export class AutologComponent implements OnInit {

  token: string;
  dossierNumber: string;
  errorMsgAutoconnect = '';
  PAGE_CONNEXION = '/auth/signin';
  TITRE_POPIN = '';

  chromeURL = 'intent:' + environment.visiotexBaseURL.substring(6, environment.visiotexBaseURL.length) +
    '/maVisio#Intent;package=com.android.chrome;scheme=https;S.browser_fallback_url=www.google.com;end';
  edgeURL = 'intent:' + environment.visiotexBaseURL.substring(6, environment.visiotexBaseURL.length) +
    '/maVisio#Intent;package=com.microsoft.emmx;scheme=https;S.browser_fallback_url=www.google.com;end';

  constructor(private route: ActivatedRoute, private router: Router, private autologService: AutologService,
              private detectBrowserService: DetectBrowserService, private sanitizer: DomSanitizer) {
  }


  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.token = params['c'];
      this.dossierNumber = params['ref'];
    });

    this.chromeURL = 'intent:' + environment.visiotexBaseURL.substring(6, environment.visiotexBaseURL.length) +
      '/maVisio/#/a?ref=' + this.dossierNumber + '&c=' + this.token +
      '#Intent;package=com.android.chrome;scheme=https;S.browser_fallback_url=www.google.com;end';
    this.edgeURL = 'intent:' + environment.visiotexBaseURL.substring(6, environment.visiotexBaseURL.length) +
      '/maVisio/#/a?ref=' + this.dossierNumber + '&c=' + this.token +
      '#Intent;package=com.microsoft.emmx;scheme=https;S.browser_fallback_url=www.google.com;end';

    if (this.detectIncompatibleBrowser()) {
      this.autologService.login(this.dossierNumber, this.token).subscribe(response => {
        if (response) {
          localStorage.setItem('tokenConnexion', response.Hash);
          localStorage.setItem('refSinistre', response.Number);
          const rdv = new Rendezvous;
          rdv.begin = response.BeginRdvDate;
          rdv.end = response.EndRdvDate;
          localStorage.setItem('rendezvous', JSON.stringify((rdv)));

          this.router.navigate(['/dossier']);
        } else {
          this.TITRE_POPIN = 'Impossible de trouver le dossier';
          this.errorMsgAutoconnect = 'Dossier introuvable.\n' +
            'Nous vous invitons à vous connecter avec vos identifiants.';
        }
      }, () => {
        this.TITRE_POPIN = 'Erreur technique';
        this.errorMsgAutoconnect = 'Une erreur technique est survenue.';
      });
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  detectIncompatibleBrowser(): boolean {
    return this.detectBrowserService.isBrowserCompatible();
  }

}



// WEBPACK FOOTER //
// ./src/app/autolog/autolog.component.ts